import { withProps } from 'recompose';
import config from '../../config';

export default withProps({
  urlPattern: config.urlPatterns.kiosk,
});



// WEBPACK FOOTER //
// ./src/app/hoc/WithKioskUrlPattern.js